// code对应提示信息的国际化字段
const codeKey = {
  "0x02401a00": "error.code.api.nameExisted",
  "0x02401a01": "error.code.api.proNotExisted",
  "0x02401a02": "error.code.api.notExisted",
  "0x02401a03": "error.code.api.groupNotExisted",
  "0x02401a04": "error.code.api.groupHasSub",
  "0x02401a05": "error.code.api.fileError",

  "0x02401a10": "error.code.group.nameExisted",
  "0x02401a11": "error.code.group.notExisted",
  "0x02401a12": "error.code.group.hasApi",
  "0x02401a13": "error.code.group.hasSub",
  "0x02401a14": "error.code.group.pNotExisted",
  "0x02401a15": "error.code.group.pHasApi",

  "0x02401a20": "error.code.pro.notExisted",
  "0x02401a21": "error.code.pro.hasApi",
  "0x02401a22": "error.code.pro.nameExisted",
  "0x02401a23": "error.code.pro.serviceIdExisted",
  "0x02401a24": "error.code.pro.addressExisted",

  "0x02401a30": "error.code.con.notExisted",
  "0x02401a31": "error.code.con.nameExisted",
  "0x02401a32": "error.code.con.appKeyExisted",
  "0x02401a33": "error.code.con.fileIllegal",
  "0x02401a34": "error.code.con.appKeyIllegal",
  "0x02401a35": "error.code.con.appSecretIllegal",
  "0x02401a36": "error.code.con.validTimeIllegal",


  "0x02401a40": "error.code.limit.notExisted",
  "0x02401a41": "error.code.limit.nameExisted",

  "0x02401a50": "error.code.config.notExisted",       // 配置项不存在
  "0x02401a51": "error.code.config.existed",      // 配置项已存在

  "0x02401a60": "error.code.upload.notExisted",
  "0x02401a61": "error.code.upload.nameExisted",
  "0x02401a63": "error.code.upload.fileNotExisted",
  "0x02401a64": "error.code.upload.uploadFileError",
  "0x02401a65": "error.code.upload.fileDownError",

  "0x02401a70": "error.code.doc.notExisted",          // 文档不存在
  "0x02401a71": "error.code.doc.pNodeNotExisted",     // 文档父节点不存在
  "0x02401a72": "error.code.doc.fileExportFail",       // 文档导出失败
  "0x02401a73": "error.code.doc.titleExisted"         // 文档标题已存在
};

/**
 * 根据 code、key 返回提示信息的国际化 key 字段
 * @param {String} code 错误码
 * @param {String} key 报错信息key值
 */
export function errorCodeKey(code, key) {
  return codeKey[code] || key || 'con.addedit.serverError';
}
